export default {"src":"/pro/_next/static/media/blast-logo.577e2a7f.svg","height":24,"width":115,"blurWidth":0,"blurHeight":0};